<template>
  <v-container>
    <v-btn fab fixed dark bottom right color="primary" @click="openCreateModel">
      <v-icon>add</v-icon>
    </v-btn>
    <br />
    <v-card class="mx-auto" max-width="1020">
      <v-card-title>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-card-title>
      <v-container fluid>
        <br />
        <v-row dense>
          <v-col v-for="campaigns in data" :key="campaigns.id" :cols="4">
            <v-card>
              <v-img
                src="https://thelyst.com/wp-content/uploads/2015/07/campaign-blog-graphic-01-1080x675.jpg"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
              >
                <v-card-title v-text="campaigns.name"></v-card-title>
              </v-img>
              <v-card-actions>
                <v-btn
                  small
                  color="primary"
                  @click="onTiers(campaigns.ref_campaign_id)"
                  >Tiers</v-btn
                >
                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon>info</v-icon>
                </v-btn>

                <v-btn icon @click="openEditModel(campaigns)">
                  <v-icon>edit</v-icon>
                </v-btn>

                <v-btn icon @click="opendeleteModel(campaigns.application_id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <PrizingModel
      @openmodel="closeModel"
      v-if="prizingModal"
      :btnTitle="btn"
      :title="modalTitle"
      :item="itemData"
      @getPrizing="getPrizing"
      :deleteModal="showModelType"
    ></PrizingModel>
  </v-container>
</template>

<script>
import api from '@/clients/prizingapi/prizing'
import header from './tableColumns'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    PrizingModel: () => import('./prizing-model')
  },
  data: () => ({
    data: [],
    search: '',
    prizingModal: false,
    modalTitle: ' ',
    btn: '',
    headers: header,
    itemData: [],
    showModelType: true
  }),
  mounted () {
    this.getPrizing()
  },

  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  },
  methods: {
    /**
     * To get a list of prizing
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getPrizing () {
      this.spinner(true)
      api
        .getPrizing()
        .then(res => {
          this.data = res.data.payload
          this.prizingModal = false
        })
        .catch(error => {
          throw error
        }).finally(() => this.spinner(false))
    },
    /**
     * open Edit Model
     * @function
     */
    openEditModel (val) {
      this.modalTitle = 'Edit Campaign'
      this.btn = 'Update'
      this.prizingModal = true
      this.itemData = val
      this.showModelType = true
    },
    /**
     * open Create Model
     * @function
     */
    openCreateModel () {
      this.modalTitle = 'Create Campaign '
      this.btn = 'Save'
      this.prizingModal = true
      this.itemData = { }
      this.showModelType = true
    },
    /**
     * open Delete Model
     * @function
     */
    opendeleteModel (val) {
      this.modalTitle = 'Delete Prizing '
      this.btn = 'Delete'
      this.prizingModal = true
      this.itemData = val
      this.showModelType = false
    },
    /**
     * set value of PrizingModel False
     * @function
     */
    closeModel () {
      this.prizingModal = false
    },
    onTiers (event) {
      console.log(event)
      this.$router.push({ path: `/tiers/${event}` })
      console.log('_____')
    },
    ...mapActions({
      va_setActiveBusinessBranding: 'auth/setActiveBusinessBranding'
    })
  }
}
</script>

<style lang="scss" scoped></style>
